import _ from 'lodash';
import { parseClosingDate } from './helpers';

const userDataKeys = {
  zipCode: 'person_address_zipcode',
  street: 'person_address_street',
  streetNumber: 'person_address_number',
  floor: 'person_address_floor',
  departament: 'person_address_departament',
  mail: 'person_mail',
  gender: 'person_gender',
  phone: 'person_phone',
  cardType: 'card_brand',
  requestId: 'request_number',
  branchOffice: 'branch',
  branchAddress: 'branch_address',
  document: 'person_document',
  cuil: 'person_tributary_key',
  date: 'contract_date',
  place: 'place',
  id: 'id',
  hash: 'hash',
  status: 'id_ob_operation_status',
  state: 'person_address_province',
  //mastercardLimitSpot: "purchase_limit",
  //mastercardLimitCredit: "fees_limit",
  mastercardLimitAdvancments: "fees_limit",
  mastercardLimitUpfront: "advance_limit",
  //mastercardLimitCashAdvancments: "fees_limit",
  mastercardLimitPurchase: "purchase_limit",
  mastercardLimitFinance: "financing_limit",
  closingDate: "closing_date",
  authorized:"user",
  metadata:"metadata",
  idTypeClient:"id_type"
};

const userKeysToParse = {
  firstName: 'person_name',
  gender: 'person_gender',
  lastName: 'person_lastname',
  state: 'person_address_province',
  county: 'person_address_county',
  street: 'person_address_street',
  streetNumber: 'person_address_number',
};

const contractDataDefaults = (cardType, closingDate) => {
  cardType = _.toLower(cardType);
  if (!['mastercard', 'visa'].includes(_.toLower(cardType))) {
    return {};
  }
  const defaults = {
    name: '',
    document: '',
    branchOffice: '',
    gender: '',
    signature: '',
    requestId: '',
    date: '',
    place: '',
    creditCardType: `FTCRIH01.${cardType}_type_international`,
    [`${cardType}LimitSpot`]: '',
    paymentMethod: 'FTCRIH01.payment_method_debit',
    paymentMethodAmount: 'FTCRIH01.payment_method_debit_total',
    mastercardClosingDate: parseClosingDate(closingDate)
  };
  return defaults;
};

const userDataParser = (data) => {
  if (!data) return {};
  const userData = _.mapValues(userDataKeys, (key) => data[key]);
  const unparsed = _.mapValues(userKeysToParse, (key) => data[key]);
  const fullName = unparsed.firstName + ' ' + unparsed.lastName;
  userData.name = fullName;
  userData.fullAddress =
    _.replace(unparsed.street, /,/g, '') +
    ' ' +
    unparsed.streetNumber +
    ', ' +
    unparsed.county +
    ', ' +
    unparsed.state;
  userData.signature = _.toUpper(fullName);

  const contractDefaults = contractDataDefaults('mastercard', userData.closingDate);

  return _.merge({}, contractDefaults, userData);
};

export default userDataParser;
